import { render, staticRenderFns } from "./PartnerCard.vue?vue&type=template&id=6f625f6d&scoped=true"
import script from "./PartnerCard.vue?vue&type=script&lang=js"
export * from "./PartnerCard.vue?vue&type=script&lang=js"
import style0 from "./PartnerCard.vue?vue&type=style&index=0&id=6f625f6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f625f6d",
  null
  
)

export default component.exports